import Text from "../../../../components/ui/Text";
import batteryImage from "../../assets/images/battery.webp";

interface HeaderProps {
  className?: string;
  title: string;
  batteryPercentage: number;
}

const Header = ({ className = "", title, batteryPercentage }: HeaderProps) => {
  return (
    <header
      className={`p-1 px-2 bg-[#BEB9FF1F] flex items-center justify-between ${className}`}
    >
      <Text size="xxs" className="text-[#BEB9FF]">
        {title}
      </Text>{" "}
      <img src={batteryImage} alt="100%" className="w-[22px]" />
    </header>
  );
};

export default Header;
